import React from 'react';
import { IntlMessages } from '@/components';

const makeTableLoadingObject = (isLoading) => {
  return {
    spinning: isLoading ?? false,
    description: <IntlMessages id="ui-general-loading" />,
  };
};

export default makeTableLoadingObject;
